<template>
  <div>
    <v-app-bar
      app
      flat
      elevate-on-scroll
      outlined
      class="qmkey-app-bar"
      color="white"
      v-if="$route.name != 'login'"
    >
      <!-- Not loged user -->
      <div class="qmkey-toolbar-navigation-items" v-if="!isUser">
        <v-btn
          text 
          to="login"
          :class="'qmkey-toolbar-navigation-items' + ($route.name == 'login' ? '-active' : '')"
        >
          <span 
            :class="'guest-menu' + ($route.name == 'login' ? '-active' : '')"
          >
            {{ $vuetify.lang.translator('login') }}
          </span>
        </v-btn>
      </div>

      <!-- Site Selector and Moblie Menu Selector-->
      <div v-if="isUser" class="qmkey-toolbar-selector" @click="open_menu();">
        <div class="qmkey-toolbar-menu-icon" v-if="is_mobile">
          <v-icon large>mdi-menu</v-icon>
        </div>
        <div
          class="qmkey-toolbar-menu-image-cont"
        >
          <img
            class="qmkey-toolbar-menu-image"
            :class="is_mobile ? 'mobile-header-img' : ''"
            :src="centro_logo"
            @error="failed_logo_event"
          />
          <v-icon small style="align-items: end;">mdi-chevron-down</v-icon>
        </div>
      </div>

      <v-spacer></v-spacer>

      <!-- App Menus -->
      <NavegationMenu v-if="isUser && !is_mobile" />

      <div class="qmkey-toolbar-items">
        <!-- Global Search -->
        <SearchText v-if="isUser" @input="setSearchText" />

        <!-- Langauge Selector -->
        <!-- <div>
          <LangSelector />
        </div> -->

        <!-- Notifications -->
        <div class="pr-3" v-if="isUser">
          <NotificationsDialog />
        </div>

        <!-- User menu -->
        <UserMenu v-if="isUser" class="pr-4"/>
      </div>
    </v-app-bar>

    <!-- Site Selector Navegation drawer -->
    <SiteSelector ref="siteselector" v-if="!is_mobile"/>
    <MenuSelector v-if="isUser && is_mobile" :site_logo="centro_logo" ref="menuselector" />
  </div>
</template>


<style lang="scss">
 @import "@/sass/header.scss";
</style>


<script>
 import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
 import { resolve_logo } from '@/utils/logos';
 import NavegationMenu from '@/components/header/NavegationMenu';
 import UserMenu from '@/components/header/UserMenu';
 import SiteSelector from '@/components/header/SiteSelector'
 import NotificationsDialog from '@/components/header/NotificationsDialog'
 import SearchText from '@/components/SearchText'
 import ChangePasswordForm from '@/components/ChangePasswordForm'
 import MenuSelector from '@/components/header/MenuSelector';
 import LangSelector from '@/components/header/LangSelector';

 export default {
   name: 'HeaderMenu',

   data: () => ({
     failed_logo: false,
     show_site_selector: false,
   }),

   components: {
     SiteSelector,
     NotificationsDialog,
     SearchText,
     ChangePasswordForm,
     NavegationMenu,
     UserMenu,
     MenuSelector,
     LangSelector,
   },

   computed: {
     ...mapGetters([
       'isUser',
       'isManager',
       'isAdmin',
       'sitePath',
       'user',
       'site_data',
       'centro_id'
     ]),
     ...mapState(['is_mobile', 'centros']),

     centro_logo() {
       if (this.centros && this.centro_id)
         return resolve_logo(this.centros[this.centro_id].logo, this.failed_logo);
       return resolve_logo('^.^', true);
     },
   },

   methods: {
     ...mapMutations([
       'SET_GLOBAL_SEARCH_TEXT',
     ]),

     setSearchText(search_text) {
       this.SET_GLOBAL_SEARCH_TEXT(search_text);
       // Prevent duplicate navigation
       if (search_text && this.$route.path !='/search')
         this.$router.push({path: 'search'});
     },

     failed_logo_event() {
       this.failed_logo = true;
     },

     open_menu() {
       if (!this.is_mobile) {
         this.$refs.siteselector.show();
       } else {
         this.$refs.menuselector.show();
       }
     },
   },
 }
</script>
